import React from 'react';
import PropTypes from 'prop-types';
import { convertColorToThemeHexCode } from 'Styles/colors.util';

import * as Styled from './GiftMessageCardAdd.styled';
import ResponsiveImage from '../../../ResponsiveImage/ResponsiveImage';

/**
 * `GiftMessageCardAdd` is used as a CTA to display the GiftMessageForm within the GiftOptionsDialog
 */
const GiftMessageCardAdd = ({
  withChevron,
  onClick,
  withImage,
  title,
  description,
  className
}) => (
  <Styled.Card
    role="button"
    tabIndex="0"
    onClick={onClick}
    data-track-label="add gift message"
    data-testid="gift-message-add"
    className={className}
  >
    <Styled.CardContent>
      {withImage && (
        <Styled.Image>
          <ResponsiveImage
            src="https://assets.bombas.com/image/upload/v1604944837/mixed-grid-card-transparent_jvzber.png"
            alt="Gift Message Card"
            background={convertColorToThemeHexCode('grey40')}
            resolution={{
              small: 300
            }}
            crop={{
              height: 3040,
              width: 3040
            }}
          />
        </Styled.Image>
      )}
      <Styled.Copy>
        <Styled.Title>{title}</Styled.Title>
        <Styled.Description>{description}</Styled.Description>
      </Styled.Copy>
    </Styled.CardContent>
    <Styled.CtaButton name={withChevron ? 'chevron-right' : 'plus'} />
  </Styled.Card>
);

GiftMessageCardAdd.propTypes = {
  /**
   * Determines which cta icon to display.
   * `true` to render a "chevron-right"  icon
   * `false` to render a "plus" icon
   */
  withChevron: PropTypes.bool,
  /**
   * Handler for optional click event
   */
  onClick: PropTypes.func,
  withImage: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string
};

GiftMessageCardAdd.defaultProps = {
  withChevron: false,
  onClick: null,
  withImage: true,
  title: 'Add A Gift Message',
  description: 'You make it personal. We’ll send it with your order.',
  className: undefined
};

export default GiftMessageCardAdd;
